export default "__VITE_ASSET__BwWyIoPs__"